export default "__VITE_ASSET__fE0A_s8X__"